// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3955) return "static/chunks/3955.60706f147c8c8c59.js";
	if (chunkId === 408) return "static/chunks/408.8927f0bc89f68163.js";
	if (chunkId === 9093) return "static/chunks/9093.ebbccee7e032ca96.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"657":"5db3cbfc5ad91636","2607":"64183f3b192bc399","5508":"28e43c84e247cdc1","6152":"9d9034968c8a8b38"}[chunkId] + ".js";
};